import React, {useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {isMobile} from "../../../../../../../services/Helpers";
import CustomSwitch from "../../../../../../common/CustomSwitch";
import { Tag, Tooltip } from 'antd';
import {HStack, VStack} from "native-base";
import AppText from "../../../../../../common/AppText";
import {GlobalStyleAttributes} from "../../../../../../../styles/GlobalStyles";
import {isRTL, t} from "../../../../../../../services/i18n";
import {Colors} from "../../../../../../../styles/Colors";
import {FLOW_MANAGER_MODAL, openModal} from "../../../../../../../redux/modalManagerSlice";
import {modalFlowOptions} from "../../../../../Popups/ModalFlow/ModalFlowOptions";
import ActiveIndicator from "./ActiveIndicator";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { brands } from '@fortawesome/fontawesome-svg-core/import.macro';
import { GlobalConsts } from '../../../../../../../styles/GlobalConsts';
import CustomButtonV2 from "../../../../../../common/CustomButtonV2";
import InfoTooltip from "../../../../../../common/InfoTooltip";
import {getIsMessageTypeActive} from "../../SettingsConfig";
import { MetaWhatsappTemplateStatus } from '../../../../../../../Configs/DatabaseConsts';

const AutoMessages = (props) => {
    const { messageType, header, subheader, sectionHeader, periodAmountTextBefore, periodAmountTextAfter, sessionType} = props;
    const dispatch = useDispatch();
    const autoActions = useSelector(state => state.box.box.auto_actions)
    const messageTypeAutoActions = useMemo(() => {
        if(autoActions && autoActions.length) {
            return autoActions.filter(item => item.auto_actions.action === messageType && item.session_type === sessionType)
        }
        return []
    }, [autoActions, messageType]);
    const connetctToMetaWhatsapp = useSelector(state => state.box.box.integrations?.find(i => i.name === 'metaWhatsapp'))
    const whatsappMessageTypeAutoActions = useMemo(() => {
        if(messageTypeAutoActions && messageTypeAutoActions.length) {
            return messageTypeAutoActions.find(item => item.auto_action_type === 'WHATSAPP' && item.active)
        }
        return []
    }, [messageTypeAutoActions]);

    const whatsappTemplateStatus = useMemo(() => {
        return whatsappMessageTypeAutoActions?.message_template?.whatsapp_template?.status || null
    }, [whatsappMessageTypeAutoActions]);


    const showWhatsappTemplateStatusTag = useMemo(() => {
        return whatsappMessageTypeAutoActions && connetctToMetaWhatsapp
    }, [whatsappMessageTypeAutoActions, connetctToMetaWhatsapp]);
    const hasActiveAction = useMemo(() => messageTypeAutoActions.some(item => item.active), [messageTypeAutoActions]);

    const openAutoMessageModal = () => {
        dispatch(openModal({
            modalName: FLOW_MANAGER_MODAL,
            props: {
                initSelection: modalFlowOptions.SESSION_AUTO_MESSAGE,
                initProps: {messageType, periodAmountTextBefore, periodAmountTextAfter, sessionType: sessionType ?? null},
                target: messageTypeAutoActions,
                onSubmit: (values) => console.log('save this', values),
            },
            onClose: () => console.log('closed')}))
    }
    const whatsappTemplateStatuStyle = {
        [MetaWhatsappTemplateStatus.APPROVED]: {backgroundColor: Colors.newDesign.lightGreen, color: Colors.newDesign.mainGreen,borderColor: Colors.newDesign.white},
        [MetaWhatsappTemplateStatus.PENDING]:     {backgroundColor: Colors.newDesign.lightLightPurple, color: Colors.newDesign.purpleText,borderColor: Colors.newDesign.white},
        [MetaWhatsappTemplateStatus.NOT_APPROVED]: {backgroundColor: Colors.newDesign.redTagBackground, color: Colors.newDesign.redTagText,borderColor: Colors.newDesign.white},
        [null]: {backgroundColor: Colors.newDesign.redTagBackground, color: Colors.newDesign.redTagText,borderColor: Colors.newDesign.white},
    }

    const whatsappTemplateStatusLabel = {
        [MetaWhatsappTemplateStatus.APPROVED]:  t('meta-whatsapp-template-status-approved'),
        [MetaWhatsappTemplateStatus.PENDING]: t('meta-whatsapp-template-status-pending'),
        [MetaWhatsappTemplateStatus.NOT_APPROVED]: t('meta-whatsapp-template-status-not-approved'),
        [null]: 'NOT_APPROVED',
    }

    const whatsappTemplateError = whatsappMessageTypeAutoActions?.message_template?.whatsapp_template?.error_message;

    return (
        <VStack space={'0.7rem'}>
            {sectionHeader &&
            <HStack mt={'-0.5rem'}>
                <AppText fontSize={GlobalStyleAttributes.fonts.standard16} boldFont>{sectionHeader.title}</AppText>
                {sectionHeader.tooltip && <InfoTooltip title={sectionHeader.tooltip} />}
            </HStack>}
            <CustomButtonV2 onClick={openAutoMessageModal} override={({isHovered}) =>
                <VStack space={'0.3rem'} borderWidth={'1px'} borderColor={isHovered ? Colors.newDesign.mainBlue : Colors.borderColor} borderRadius={'5px'} padding={'15px'} flex={1}>
                    <HStack space={'0.5rem'} alignItems={'center'}>
                        <ActiveIndicator isActive={hasActiveAction}/>
                        <AppText fontSize={GlobalStyleAttributes.fonts.standard16} boldFont>{header}</AppText>
                    </HStack>
                    <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{subheader}</AppText>
                    {showWhatsappTemplateStatusTag && (
                        <HStack
                            style={{ position: 'absolute', left: isRTL() ? '0' : 'auto', right: isRTL() ? 'auto' : '0', top: '8px' }}
                            alignItems="center"
                            space="4px"
                        >
                            <FontAwesomeIcon icon={brands('whatsapp')} color={Colors.newDesign.darkGrey} />

                            {whatsappTemplateStatus == MetaWhatsappTemplateStatus.NOT_APPROVED && whatsappTemplateError && (
                                <>
                                    <InfoTooltip title={whatsappTemplateError} />
                                </>
                            )}
                            <Tag style={whatsappTemplateStatuStyle[whatsappTemplateStatus]}>
                                {whatsappTemplateStatusLabel[whatsappTemplateStatus]}
                            </Tag>
                        </HStack>
                    )}
                </VStack>
            }/>
        </VStack>
    );
};

export default AutoMessages;
